<template lang="pug">
    .play-box
        template(v-if='!isLoading')
            game-header(
                v-if="!isBattle"
                @soundStateChanged ="headerKey = !headerKey"
                :key="headerKey"
                :slug='type',
                :game-type='parameters && parameters.courseType',
                :is-homework="!!exerciseId",
            )
            .play-box__game(v-if='gameStarted && !gameFinished')
                .play-box__example
                    template
                        .play-box__header(:class="{'mobile-version': isMobile}")
                            .play-box__scaling-bar-block
                                scaling-bar(
                                    v-model="fontSize"
                                    :element-name="'play-box__sentence-wrapper'"
                                    :key="clientWidth"
                                )
                        .play-box__overflow-container
                            .play-box__sentence-wrapper(:style="wordStyle")
                                .play-box__sentence(
                                    v-on:selectstart.prevent
                                    v-for="word in sentenceForCurrentExample"
                                    :style="getStyle(word)"
                                    @click="insertUserAnswer(word)"
                                )
                                    div(:style="{minHeight: calculatedMinHeight + 'px'}") {{  word.selectedItem ? $i18n.t(`trainer.trainer_gameFormSetting_${word.selectedItem}Short`) : '' }}
                                    div(ref="divRef") {{ word.word }}
                            .play-box__answers-field
                                .play-box__possible-answer(
                                    v-for="answer in possibleAnswers"
                                    @click="chooseUserAnswer(answer)"
                                ) {{ $i18n.t(`trainer.trainer_gameFormSetting_${answer}`) }}
                            cs-button.play-box__next-example-button(
                                v-if="!isDictationMode && isCorrectAnswerChosen",
                                @click="nextExample",
                                pattern="primary-outline",
                                color="blue"
                            )  {{ $i18n.t('olympiads.olympiads_processStage_further') }}
                            cs-button.play-box__next-example-button(
                                v-if="!isDictationMode && !isCorrectAnswerChosen",
                                @click="processReply(false)"
                                pattern="primary-outline",
                                color="blue"
                            )  {{ $i18n.t('trainer.trainer_gamePlayBox_check') }}
                            cs-button.play-box__next-example-button(
                                v-if="!isDictationMode && !isCorrectAnswerChosen",
                                @click="clearUserAnswer"
                                pattern="primary-outline",
                                color="blue"
                            )  {{ $i18n.t('trainer.trainer_gamePlayBox_clear') }}
            .game-info__block(v-if="gameStarted && !gameFinished")
                game-info(
                    :score="{left: answers.good, right: answers.bad}"
                    :time="getTime"
                    :slug="type"
                    :parameters="parameters"
                    :game-allows-tips="false"
                    :game-allows-description="false"
                    :opponent="opponent"
                    :opponent-numbers="opponentNumbers"
                    :is-opponent-answering="isOpponentAnswering"
                    :is-from-battle="isBattle"
                    :is-olympiad="isOlympiad"
                )
            .divide-it-right__answer-buttom(v-if='isDictationMode && gameFinished && !showAnswersInDictationMode')
                img.divide-it-right__answer-turtle(:src="turtle")
                cs-button(@click='showAnswerInDictationMode' v-focus='')
                    | {{ $i18n.t('trainer.trainer_gamePlayBox_showAnswers') }}
            examples-viewer(
                v-if="showAnswersInDictationMode"
                :examples-array="examplesArrayForDictationMode"
                :possible-answers="possibleAnswers"
            )
            .play-box__end-container(v-if='gameFinished && !isOlympiad && !isDictationMode')
                fireworks(
                    v-if="gameFinished && !isOlympiad && gameResult === 'success' "
                    :is-mobile="isMobile"
                )
                .play-box__reaction-container
                    .play-box__answers.play-box__answers--left
                        | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                        br
                        | {{ getTime }}
                    result-image.play-box__image(:status="gameResult")
                    .play-box__answers.play-box__answers--right
                        | {{ $i18n.t('dashboard.dashboard_sidebar_statistics') }}
                        br
                        | {{ answers.good }} / {{ answers.bad }}
                result-buttons(
                    v-if="!isBattle"
                    :exercise-id="exerciseId"
                    :games-type="parameters.courseType"
                    show-restart-button
                    @restartGame="restartGame"
                )
                    slot
            calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
        cs-loader(v-else)
</template>

<script>
/*eslint-disable*/
import ParsingSentencePartsSpeech from '../../../../api/games/parsingSentencePartsSpeech';
import textScrollMixin from '../../../../utils/trainer/textScroll';
import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
import Battle from '../../../../utils/battle/battleMixin';
import olympiadRussianLanguageAnswerTimerMixin from '../../../../utils/olympiads/olympiadRussianLanguageAnswerTimerMixin.js';
import { cloneDeep } from 'lodash';
import CsButton from '@/elements/CsButton.vue';
import CsLoader from '@/elements/CsLoader.vue';
import CalculatingAnswers from '../../CalculatingAnswersModal.vue';
import ExamplesViewer from './ExamplesViewer.vue';
import ScalingBar from "./ScalingBar.vue";



function DEFAULT_DATA() {
    return {
        examples: null,
        fontSize: '3',
        clientWidth: 0,
        currentLevel: 0,
        answers: { good: 0, bad: 0 },
        isCorrectAnswerChosen: false,
        showAnswersInDictationMode: false,
        sentenceForCurrentExample: null,
        userAnswers: [],
        currentUserAnswer: null,
        calculatedMinHeight: 0,
    };
}

export default {
    mixins: [textScrollMixin, playBoxGameMixin, olympiadRussianLanguageAnswerTimerMixin, Battle],
    data() {
        return DEFAULT_DATA();
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeyPress);
    },
    updated() {
        this.calculatedMinHeight = this.$refs.divRef ? this.$refs.divRef[0].clientHeight : 0;
    },
    beforeDestroy() {
        this.beforeTabClosed();
        document.removeEventListener('keydown', this.handleKeyPress);
        window.removeEventListener('beforeunload', this.beforeTabClosed);

    },
    watch: {
        time: {
            handler(val) {
                if (
                    this.parameters?.timeLimit !== 0 &&
                    val >= this.parameters?.timeLimit * 60 &&
                    !this.gameFinished
                ) {
                    this.finishGame();
                }
                if (this.isDictationMode && val % this.parameters?.timeForAnswer === 0) {
                    this.nextExample();
                }
            },
        },
    },
    computed: {
        possibleAnswers () {
            let arr = [];
            this.parameters.selectedParts.forEach((obj) => {
                    arr.push(obj.value)
                }
            )
            return arr;
        },
        examplesArrayForDictationMode() {
            const arr = cloneDeep(this.examples);
            arr.length = this.parameters.amountOfExamples;
            return arr;
        },
        turtle() {
            return require(`../../../../assets/images/turtle/ru/ru_AnswerTurtle.svg`);
        },
        gameResult() {
            if (this.answers.good >= this.answers.bad) return 'success';
            else return 'failure';
        },
        wordStyle() {
            return {
                'font-size': this.fontSize + 'em',
            };
        },
        isDictationMode() {
            return this.parameters.dictation;
        },
        isInfiniteAmountOfExamples() {
            return this.parameters.timeLimit || this.parameters.infinityAmountOfExamples;
        },
    },
    methods: {
        getStyle(word) {
            if (!word.isNonWordItem) {
                return {
                    'margin-left': '15px',
                    'color': this.getWordColor(word),
                }
            }
        },
        getWordColor(word) {
            if (word.isCorrect) {
                return 'hsl(121, 36%, 50%)';
            }
        },
        chooseUserAnswer(answer) {
            this.currentUserAnswer = answer;
        },
        insertUserAnswer(word) {
            if (word.isNonWordItem) return;
            if (word.isCorrect) return;
            if (word.selectedItem === this.currentUserAnswer) {
                word.selectedItem = '';
                word.isAnswered = false;
            } else {
                word.selectedItem = this.currentUserAnswer;
                word.isAnswered = true;
            }
        },
        checkUserAnswer() {
            const arrayOfRightAnswers = this.examples[this.currentLevel].sentenceParts;
            this.sentenceForCurrentExample.forEach((obj) => {
                arrayOfRightAnswers.forEach((rightAnswerObj) => {
                    if (obj.word.toLowerCase() === rightAnswerObj.sentencePartValue.toLowerCase() && !obj.isCorrect && obj.isAnswered) {
                        if (obj.selectedItem.toLowerCase() === rightAnswerObj.sentencePart.toLowerCase()) {
                            obj.isCorrect = true;
                            this.answers.good++;
                        } else {
                            obj.isCorrect = false;
                            obj.isAnswered = false;
                            obj.selectedItem = '';
                            this.answers.bad++;
                        }
                    }
                })
            })

            const userAnswersArray = this.getAnswersArray(this.sentenceForCurrentExample, this.possibleAnswers, 'word', 'selectedItem');
            const rightAnswersArray = this.getAnswersArray(arrayOfRightAnswers, this.possibleAnswers, 'sentencePartValue', 'sentencePart');
            this.isCorrectAnswerChosen = userAnswersArray.length === rightAnswersArray.length;
        },
        getAnswersArray(array, possibleAnswers, wordField, valueField) {
            return array
                .filter(obj => possibleAnswers.includes(obj[valueField]))
                .map(obj => ({
                    word: obj[wordField].toLowerCase(),
                    value: obj[valueField]
                }));
        },
        clearUserAnswer() {
            this.sentenceForCurrentExample.forEach(item => {
                item.isAnswered = false;
                if (!item.isCorrect) {
                    item.selectedItem = '';
                }
            })
        },
        handleKeyPress(event) {
            if (event.key === 'Enter') {
                if (!this.isDictationMode && !this.gameFinished) {
                    if (this.isCorrectAnswerChosen) {
                        return this.nextExample();
                    } else {
                        return this.processReply();
                    }
                }
            }
        },
        showAnswerInDictationMode() {
            this.showAnswersInDictationMode = true;
        },
        registerSounds() {
            this.$createjs.Sound.removeAllSounds();
            this.$createjs.Sound.removeAllEventListeners();
            this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
            this.$createjs.Sound.registerSounds(this.soundObjects);
        },
        fetchData() {
            this.getExercise()
                .then(() => {
                    const parts = this.parameters.selectedParts.map(obj => obj.value);
                    const classes = this.parameters.selectedClass.map(obj => obj.value);
                    ParsingSentencePartsSpeech.getItemsByRequest({
                        isInfiniteAmountOfExamples: this.isInfiniteAmountOfExamples,
                        amountOfExamples: this.parameters.amountOfExamples,
                        classes,
                        parts
                    })
                        .then(data => {
                            this.examples = data;
                            this.generateExample();
                            this.startGame();
                            this.registerSounds();
                            this.isLoading = false;
                        })
                        .catch(e => this.showErrorMessage(e));
                })
                .catch(e => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                    this.$router.push({ name: 'dashboard' });
                });
        },
        refreshGameStatBeforeSend() {
            this.gameStat.answers = this.answers.good;
            this.gameStat.amountOfMistakes = this.answers.bad;
            this.gameStat.attempts = this.answers.good + this.answers.bad;
            this.gameStat.isCompleted = this.isInfiniteAmountOfExamples ? true : this.gameFinished;
            this.gameStat.executionTime = this.time;
            this.gameStat.isCorrect = true;
            this.gameStat.percent = this.calculatePercent();
            this.gameStat.amountOfExamples = this.parameters.amountOfExamples;
            this.gameStat.parameters = cloneDeep(this.parameters);
        },
        generateExample() {
            this.sentenceForCurrentExample = this.examples[this.currentLevel].wholeSentence.split(' ').map(word => {
                return {
                    word,
                    selectedItem: '',
                    isCorrect: false,
                    isNonWordItem: /[^\wа-яё]/iu.test(word),
                    isAnswered: false,
                };
            });
        },
        startGame() {
            this.gameStarted = true;
            this.startTimer();
        },
        startTimer() {
            this.startAnswerTimer();
            this.$nextTick(() => {
                if (!this.timer) {
                    this.setTimer();
                }
            });
        },
        processReply(finishExample = false) {
            if (finishExample) {
                this.answers.bad++;
                return this.nextExample();
            }
            if (this.isDictationMode) return;
            if (this.isCorrectAnswerChosen) return;
            this.checkUserAnswer();
            if (this.isOlympiad || this.isBattle) {
                return this.nextExample();
            }
        },
        nextExample() {
            this.isCorrectAnswerChosen = false;
            this.stopAnswerTimer();
            if (!this.isInfiniteAmountOfExamples && this.currentLevel === this.parameters.amountOfExamples - 1) {
                this.finishGame();
                return;
            }
            this.currentLevel++;
            this.startAnswerTimer();
            this.generateExample();
        },
        finishGame() {
            this.gameFinished = true;
            this.stopTimer();
            if (!this.isDictationMode) {
                this.soundInstance = this.$createjs.Sound.play('gameDone');
                this.sendStat();
            }
        },
        calculatePercent() {
            let total = this.answers.good + this.answers.bad;
            if (total > 0) {
                return parseInt((this.answers.good / total) * 100);
            }
            return 0;
        },
        beforeGameRestart() {
            Object.assign(this, DEFAULT_DATA());
        },
        beforeTabClosed() {
            if (this.gameStarted) {
                this.gameFinished = true;
                this.sendStat();
            }
            return null;
        },
    },
    components: {
        ExamplesViewer,
        CsLoader,
        CsButton,
        CalculatingAnswers,
        ScalingBar,
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/sass/games/playbox.scss';

.play-box {
    display: flex;
    flex: 1 1 auto;
    justify-content: center;
    width: 100%;
    align-items: center;
    flex-direction: column-reverse;
    @include media($md) {
        align-items: stretch;
        flex-direction: row;
    }
}

.play-box__game {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column-reverse;
    width: 100%;
    @include media($lg) {
        flex-direction: row;
    }
}

.play-box__example {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-grow: 5;
    flex-direction: column;
    justify-content: center;
}

.play-box__overflow-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 7px;
    @include media($sm) {
        font-size: 8px;
    }
    @include media($md) {
        font-size: 9.5px;
    }
    @include media($lg) {
        font-size: 12px;
    }
    @include media($xl) {
        font-size: 14px;
    }
    @include media($xxl) {
        font-size: 16px;
    }
}

.play-box__sentence-wrapper{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 80%;
}

.play-box__sentence{
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.answer-container__header {
    margin-bottom: 20px;
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
}

.answer-container__input .cs-input {
    margin-bottom: 0;
    font-size: 52px;
    line-height: 62px;
    padding: 9px 15px;
    text-align: center;
    max-width: 330px;
}

.play-box__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    font-weight: 500;
    font-size: 28px;
    line-height: 34px;
    margin-bottom: 20px;
}

.play-box__before-start-game-header {
    flex-direction: column;
}

.play-box__scaling-bar-block {
    margin-left: 20px;
    @include media($xlg) {
        margin-left: 40px;
    }
}

.play-box__end-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.play-box__reaction-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    @include media($md) {
        flex-direction: row;
    }
}

.play-box__answers {
    font-weight: 500;
    font-size: 22px;
    line-height: 26px;
    text-align: center;
    @include media($lg) {
        font-size: 32px;
        line-height: 38px;
    }
    @include media($xl) {
        font-size: 42px;
        line-height: 50px;
    }
}

.play-box__answers--left {
    color: $hsl-color-green-58;
    margin-left: 20px;
    @include media($lg) {
        margin-left: 35px;
    }
}

.play-box__answers--right {
    color: $hsl-color-green-58;
    margin-right: 20px;
    @include media($lg) {
        margin-right: 35px;
    }
}

.play-box__image {
    max-width: 100%;
    margin-bottom: 40px;
    @media screen and (max-width: 1200px) {
        height: 400px;
    }
}

.warning {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
}

.play-box__answers-field {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    gap: 10px;
    overflow-x: auto;
    width: 100%;
    font-size: 20px;
    @include media($xlg) {
        gap: 20px;
        font-size: 30px;
    }
}

.play-box__possible-answer {
    cursor: pointer;
}

.play-box__answer {
    cursor: pointer;
}

.play-box__next-example-button {
    margin-top: 15px;
}

.divide-it-right__answer-buttom {
    display: flex;
    flex-direction: column;
    align-items: center;
    @include inset-space($space-base);
}

.divide-it-right__answer-turtle {
    max-width: 180px;
    @include stack-space($space-base);
    @include media($xlg) {
        max-width: 240px;
    }
}
</style>
